/**
 * How It Works Widget
 * Handles the interactive how-it-works section with step animations
 */
class HowItWorksWidget {
    constructor(options = {}) {
        this.autoAdvanceInterval = null;
        this.autoAdvanceDelay = options.autoAdvanceDelay || 3500;
        this.currentType = options.defaultType || 'renters';
        this.currentStep = 0;
        this.stepsCount = options.stepsCount || { renters: 3, hosts: 3 };
        this.manualPauseTimeout = null;
        this.hasToggle = options.hasToggle || false;
        
        this.init();
    }

    init() {
        this.bindEvents();
        this.showStep(this.currentType, 0);
        this.startAutoAdvance();
        
        if (this.hasToggle) {
            this.toggleActionButtons(this.currentType);
        }
    }

    showStep(type, stepIdx) {
        // Show/hide steps
        document.querySelectorAll('.howit-step').forEach(step => {
            if (step.getAttribute('data-type') === type && step.getAttribute('data-step') == stepIdx) {
                step.classList.add('active');
                step.style.display = 'flex';
            } else if (step.getAttribute('data-type') === type) {
                step.classList.remove('active');
                step.style.display = 'flex';
            } else {
                step.classList.remove('active');
                step.style.display = 'none';
            }
        });

        // Show/hide images
        document.querySelectorAll('.howit-img').forEach(img => {
            img.classList.remove('active');
            img.style.display = 'none';
        });

        const img = document.querySelector('.howit-img-' + stepIdx + '.' + type);
        if (img) {
            img.classList.add('active');
            img.style.display = 'block';
        }
    }

    startAutoAdvance() {
        clearInterval(this.autoAdvanceInterval);
        this.autoAdvanceInterval = setInterval(() => {
            this.currentStep++;
            if (this.currentStep >= this.stepsCount[this.currentType]) {
                this.currentStep = 0; // Loop within the selected tab only
            }
            this.showStep(this.currentType, this.currentStep);
        }, this.autoAdvanceDelay);
    }

    stopAutoAdvance() {
        clearInterval(this.autoAdvanceInterval);
    }

    toggleActionButtons(type) {
        const rentersBtn = document.querySelector('.renters-btn');
        const hostsBtn = document.querySelector('.hosts-btn');
        
        if (rentersBtn) {
            rentersBtn.classList.toggle('active', type === 'renters');
        }
        if (hostsBtn) {
            hostsBtn.classList.toggle('active', type === 'hosts');
        }
    }

    bindEvents() {
        // Toggle between renters/hosts (if toggle exists)
        document.querySelectorAll('.howit-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                document.querySelectorAll('.howit-btn').forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                this.currentType = btn.getAttribute('data-type');
                this.currentStep = 0;
                this.showStep(this.currentType, this.currentStep);
                this.startAutoAdvance();
                if (this.hasToggle) {
                    this.toggleActionButtons(this.currentType);
                }
            });
        });

        // Step selection
        document.querySelectorAll('.howit-step').forEach(step => {
            step.addEventListener('click', () => {
                const type = step.getAttribute('data-type');
                const stepIdx = parseInt(step.getAttribute('data-step'));
                this.currentType = type;
                this.currentStep = stepIdx;
                this.showStep(type, stepIdx);

                // Pause auto-advance and restart after a delay
                this.stopAutoAdvance();
                if (this.manualPauseTimeout) clearTimeout(this.manualPauseTimeout);
                this.manualPauseTimeout = setTimeout(() => {
                    this.startAutoAdvance();
                }, 3000); // 3 seconds pause
            });
        });
    }
}

// Auto-initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
    const container = document.querySelector('.how-it-works-container');
    if (container) {
        // Check if this is the full version with toggle buttons
        const hasToggle = document.querySelector('.howit-toggle') !== null;
        
        new HowItWorksWidget({
            hasToggle: hasToggle,
            defaultType: hasToggle ? 'renters' : 'hosts',
            stepsCount: hasToggle ? { renters: 3, hosts: 3 } : { hosts: 3 }
        });
    }
});
